import * as React from 'react';
import { Container, AppBar, Box, Toolbar, Typography, Menu, IconButton, Avatar, Tooltip, MenuItem, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { ChevronLeft } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

import { selectorAuth } from '@core/slice/login.slice';
import { useAppSelector } from '@store/hooks';
import { loginService } from '@core/services';
import { PathsEnum } from '@routes/enumerators/paths.enum';
import { formatLocationPath, podeAcessarPerformanceProdutos } from '@core/utils';

import { ReactComponent as LogoSTZ } from '@assets/logo.svg';
import { ReactComponent as LogoOuze } from '@assets/ouze.svg';

import styled from '@emotion/styled/macro';
import { pages } from '@core/components/organisms/menu-items';

export const PageStyled = styled.div`
    padding-top: 56px;
    @media (min-width: 600px) {
        padding-top: 64px;
    }
`;

interface IAppBarProps {}

export const StzBar: React.FC<IAppBarProps> = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const {
        auth: { user }
    } = useAppSelector(selectorAuth);

    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handlingLogout = () => {
        loginService.logout();
        navigate(PathsEnum.LOGIN);
    };
    const handleGoBack = () => {
        const parts = location.pathname.split('/');
        if (parts.length > 2) {
            if (parts.length > 5) {
                window.history.back();
            } else {
                const diff = parts.length - 3;
                const newPath = parts.slice(0, -diff).join('/');
                navigate(newPath);
            }
        } else if (parts.length === 2) {
            navigate(PathsEnum.COLABORADOR);
        }
    };

    return (
        <PageStyled>
            <AppBar position="fixed" elevation={0}>
                <Container maxWidth="xl" sx={{ px: '2rem' }}>
                    <Toolbar disableGutters style={{ justifyContent: 'space-between' }}>
                        <Box
                            sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', mr: 1, height: '56px', textDecoration: 'none', cursor: 'pointer' }}
                            onClick={() => navigate(PathsEnum.COLABORADOR)}
                        >
                            <LogoSTZ style={{ height: '24px', fill: '#fff', padding: '16px 0', marginRight: '16px' }} />
                            <LogoOuze style={{ height: '16px', padding: '16px 0', marginRight: '16px' }} />
                        </Box>

                        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                            <IconButton sx={{ px: 0 }} size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu} color="inherit">
                                <MenuIcon />
                            </IconButton>

                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left'
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' }
                                }}
                            >
                                {pages.map((page) => {
                                    if (page.path.split('/').length <= 3 && page.visible && !page.path.startsWith('/varejo')) {
                                        return (
                                            <MenuItem
                                                key={page.name}
                                                onClick={() => {
                                                    navigate(page.path);
                                                    handleCloseNavMenu();
                                                }}
                                                disabled={page.disabled}
                                            >
                                                <Typography textAlign="center">{page.name}</Typography>
                                            </MenuItem>
                                        );
                                    }
                                    return null;
                                })}
                                {pages.map((page) => {
                                    if (page.path.startsWith('/varejo') && page.visible && podeAcessarPerformanceProdutos(user)) {
                                        return (
                                            <MenuItem
                                                key={page.name}
                                                onClick={() => {
                                                    navigate(page.path);
                                                    handleCloseNavMenu();
                                                }}
                                                disabled={page.disabled}
                                            >
                                                <Typography textAlign="center">{page.name}</Typography>
                                            </MenuItem>
                                        );
                                    }
                                    return null;
                                })}
                            </Menu>
                        </Box>

                        <Box
                            sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', mr: 1, height: '56px', textDecoration: 'none', cursor: 'pointer' }}
                            onClick={() => navigate(PathsEnum.COLABORADOR)}
                        >
                            <LogoSTZ style={{ height: '24px', fill: '#fff', padding: '16px 0', marginRight: '16px' }} />
                            <LogoOuze style={{ height: '16px', padding: '16px 0' }} />
                        </Box>

                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {/* {pages.map((page) => (
                            <Button key={page.path} onClick={() => navigate(page.path)} sx={{ my: 2, color: 'white', display: 'block' }}>
                                {page.name}
                            </Button>
                        ))} */}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            <Tooltip title={user?.nome || '-'}>
                                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                    <Avatar sx={{ bgcolor: '#FF00FF' }} alt={user?.nome || '-'}>
                                        {user?.initials || '-'}
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >
                                <MenuItem key="Logout" onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center" onClick={handlingLogout}>
                                        Sair
                                    </Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
            {location.pathname !== PathsEnum.COLABORADOR && (
                <Container maxWidth={false} sx={{ borderBottom: 1, borderColor: 'divider', px: '0', py: '5px', mb: 3 }}>
                    <Box style={{ display: 'flex', alignItems: 'center', maxWidth: '1536px', margin: '0 auto' }}>
                        <Button onClick={handleGoBack} sx={{ minWidth: 'unset', px: '5px' }}>
                            <ChevronLeft style={{ transform: 'translateY(1.5px)' }} />
                        </Button>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {pages.find((page) => page.path === formatLocationPath(location.pathname))?.name}
                        </Typography>
                    </Box>
                </Container>
            )}
        </PageStyled>
    );
};
// onClick={handlingLogout}
